import {Http, http} from "../http";

export const gppProduct = async (lang) =>{
    const httpNew = new Http(lang)
    const formData ={
        "sourceId": "1"
    }
    const {data}  = await  httpNew.post('gpp/product',formData)
    return data;
}

export const gppCheck = async (formData,lang) =>{
    const httpNew = new Http(lang)
    const { data } = await   httpNew.post('gpp/check',formData)
    return data;
}


export const gppclassificationCode = async (formData,lang) =>{

    const httpNew = new Http(lang)
    const { data } = await   httpNew.post('gpp/classification-codes',formData)
    return data;
}

export const calculateCommision = async (formData,lang) =>{

    const httpNew = new Http(lang)
    const { data } = await   httpNew.post('gpp/calculate-commission',formData)
    return data;
}

export const partialPayment = async (formData,lang) =>{
    const httpNew = new Http(lang)
    const { data } = await   httpNew.post('gpp/partial-payment-amount',formData)
    return data;
}

export const moneyTransferGpp = async (formData:any,language:any) =>{

    const httpNew = new Http(language)
    const { data } = await httpNew.post('moneytransfer/gpp-transaction',formData)
    return data;


}

export const getPaymentcheck= async(ibankref,lang)=>{
    const httpNew = new Http(lang)
    const ibankData =
    {
        "ibankRef":ibankref
    }

    const { data } = await httpNew.post(`gpp/receipt-by-id`,ibankData)
    return data;
}